import './ObjectivesManagementModal.css';

import React from 'react';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import DimQuantitativeObjectiveManagement from './dim-quant/DimQuantitativeObjectiveManagement';
import QuantitativeObjectiveManagement from './quant/QuantitativeObjectiveManagement';
import { isIndicatorDimensional } from '../components/helper';
import QualitativeObjectiveManagement from './qual/QualitativeObjectiveManagement';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const ObjectivesManagementModal = ({ open, areaIndicator, onClose = null, onRefresh = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const isDimensional = isIndicatorDimensional(areaIndicator.indicatorDTO);

    return (
        <B2BPopUpForm
            open={open}
            title={<span>{t('Area indicator objectives')} [{areaIndicator.areaIndicatorName}]</span>}
            onClose={onClose}
            className={'objectives-management-modal b2b-light-01'}
        >
            {areaIndicator.indicatorDTO.indicatorType === 'QUALITATIVE' ? (
                <QualitativeObjectiveManagement areaIndicator={areaIndicator} onRefresh={onRefresh} />
            ) : areaIndicator.indicatorDTO.indicatorType === 'QUANTITATIVE' ? (
                <QuantitativeObjectiveManagement areaIndicator={areaIndicator} onRefresh={onRefresh} />
            ) : areaIndicator.indicatorDTO.indicatorType === 'QUANTITATIVE_DIMENSIONAL' ? (
                <DimQuantitativeObjectiveManagement areaIndicator={areaIndicator} onRefresh={onRefresh} />
            ) : null}
        </B2BPopUpForm>
    );
};

export default ObjectivesManagementModal;